import {
    hoverFunc
} from './_hoverFunc';

export function ajaxIdxBtn() {
    var TotalPostNum, totalPost, ajaxBtnHome, ajaxBtnDate, nowCount, onCount,Loading,datePost,resultDate;
    TotalPostNum = '#TotalPostNum';
    ajaxBtnHome = '#ajaxH';
    ajaxBtnDate = '#ajaxD';
    datePost = '#postDate';
    
    Loading = '#loading';

    //合計記事数
    totalPost = $(TotalPostNum).text();
    //文字列から数値に変換
    totalPost = Number(totalPost);
    
    //年度を取得
    resultDate = $(datePost).text();
    //年度の文字列から数値に変換
    resultDate = Number(resultDate);
    
    //現在表示されている記事数
    nowCount = $('.postBlock').find('.postColumnBlock').length;
    //console.log('現在表示されている記事数:' + nowCount);

    if (nowCount == totalPost) {
        $('.ajaxBtnLayout').hide();
    }

    //home.phpの場合の挙動
    $(ajaxBtnHome).on('click', function () {
        //ボタンを非表示
        $(ajaxBtnHome).hide();
        //ローディングを表示
        $(Loading).show();
        //現在の表示記事数を取得
        onCount = $('.postBlock').find('.postColumnBlock').length;
        
        if (onCount < totalPost) {
            $.ajax({
                url: "/ristorante/ajax/ajax.php",
                type: 'POST',
                data: {
                    'posts_per_page': '15',
                    'offset': onCount,
                    'wpDate': resultDate,
                },
            }).done(function (data) {
                $('.postBlock').append(data);
                $(Loading).hide();
                $(ajaxBtnHome).show();
                hoverFunc();
                onCount = $('.postBlock').find('.postColumnBlock').length;
                if (onCount == totalPost) {
                    $('.ajaxBtnLayout').hide();
                    $('.postBlock').addClass('notPost');
                }
            }).fail(function (data) {
                alert('error!!!');
                $(Loading).hide();
            });
        }
    });

}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_ajaxBtn.js
// module id = 12
// module chunks = 0